import { IonItem, IonTabButton } from "@ionic/react";

import styles from "./shared.module.css";

interface DesktopButtonProps {
  /**
   * Used internally by Ionic. Pass down.
   */
  tab: string;

  /**
   * Ionic will change. Pass down. Do not access/use directly.
   */
  href: string;

  children?: React.ReactNode;
}

export default function SharedDesktopButton({
  href,
  children,
  ...rest
}: DesktopButtonProps) {

  return (
    <IonItem
      className={styles.tabButton}
      lines="none"
      routerLink={href}
      detail={false}
      {...rest}
    >
      {children}
    </IonItem>
  );
}
